import { v4 as uuidv4 } from 'uuid';

export function SkuSelector(props = {}, childrenComponents = []) {
	return {
		componentName: 'SkuSelector',
		componentId: uuidv4(),
		props: Object.assign(
			{
				showVariationsLabels: 'variation',
				showValueForVariation: 'none',
				variationsSpacing: 5,
				imageHeight: 40,
				imageWidth: 40,
			},
			props,
		),
		childrenComponents,
	};
}
